<template>
  <footer
        class="admin__footer flex flex-col items-center sm:items-start justify-between"
      >
        <p class="text-muted text-center sm:text-left">
          Powered by
          <a href="http://hmaserv.com/" rel=”nooopener” target="_blank">HMASERV</a>
        </p>
      </footer>
</template>


<style lang="scss" scoped>
  .admin__footer{
      min-height: var(--admin-footer);
      p{
          margin: 0;
      }
  }
</style>